import { useState, useEffect, useCallback } from "react"

const useSwipeScroll = ({
  sliderRef,
  reliants = [],
  momentumVelocity = 0.5
}: any) => {
  const [hasSwiped, setHasSwiped] = useState(false)
  const init = useCallback(() => {
    let _a
    let _b
    let slider =
      (_b =
        (_a =
          sliderRef === null || sliderRef === void 0
            ? void 0
            : sliderRef.current) === null || _a === void 0
          ? void 0
          : _a.container) === null || _b === void 0
        ? void 0
        : _b.getElementsByClassName("p-datatable-scrollable-body")
    slider = (slider === null || slider === void 0 ? void 0 : slider.length)
      ? slider[
          (slider === null || slider === void 0 ? void 0 : slider.length) - 1
        ]
      : null
    if (slider) {
      let isDown = false
      let startX: any
      let scrollLeft: any
      slider.addEventListener("mousedown", (e: any) => {
        isDown = true
        slider.classList.add("active")
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
        cancelMomentumTracking()
      })
      slider.addEventListener("mouseleave", () => {
        isDown = false
        slider.classList.remove("active")
      })
      slider.addEventListener("mouseup", () => {
        slider.classList.remove("mouse-grabbing")
        isDown = false
        slider.classList.remove("active")
        beginMomentumTracking()
        setTimeout(() => setHasSwiped(false), 0)
      })
      slider.addEventListener("mousemove", (e: any) => {
        if (!isDown) return
        slider.classList.add("mouse-grabbing")
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3
        const prevScrollLeft = slider.scrollLeft
        slider.scrollLeft = scrollLeft - walk
        velX = slider.scrollLeft - prevScrollLeft
        if (slider.scrollLeft - prevScrollLeft && !hasSwiped) {
          setHasSwiped(true)
        }
      })
      slider.addEventListener("wheel", () => {
        cancelMomentumTracking()
      })
    }
    let velX = 0
    let momentumID: any
    function beginMomentumTracking() {
      cancelMomentumTracking()
      momentumID = requestAnimationFrame(momentumLoop)
    }
    function cancelMomentumTracking() {
      cancelAnimationFrame(momentumID)
    }
    function momentumLoop() {
      slider.scrollLeft += velX
      velX *= momentumVelocity
      if (Math.abs(velX) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop)
      }
    }
  }, [])
  useEffect(() => {
    init()
  }, [...reliants])
  return {
    hasSwiped,
  }
}
export default useSwipeScroll
